module.exports = __webpack_public_path__ + "static/media/enrpi-desktop-screens.6d6df1f4.png";